import { render, staticRenderFns } from "./profile-item.vue?vue&type=template&id=bc1e5226&scoped=true&"
import script from "./profile-item.vue?vue&type=script&lang=js&"
export * from "./profile-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e5226",
  null
  
)

export default component.exports